import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39e1f3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-order w-full col-12 xl:col-3 flex flex-column p-0 h-full" }
const _hoisted_2 = { class: "pos-wrapper w-full p-4 flex flex-column justify-content-between bg-white h-full mt-2 products-order-wrapper" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "font-semibold mt-0" }
const _hoisted_5 = { class: "blue-text font-bold" }
const _hoisted_6 = { class: "part-name-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Current Order:", -1))
const _hoisted_8 = { class: "products-list-wrapper pr-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "grid pointer focus:surface-200",
  tabindex: "0"
}
const _hoisted_11 = { class: "col-8 name-section" }
const _hoisted_12 = { class: "blue-text font-bold product-name-label inline-block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "part-name-label inline-block" }
const _hoisted_15 = { class: "col-4 flex flex-column align-items-end justify-content-between" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-trash pointer",
  style: {"color":"red"}
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "flex align-items-end" }
const _hoisted_21 = {
  key: 0,
  class: "block strikethrough original-price"
}
const _hoisted_22 = { class: "font-bold ml-1" }
const _hoisted_23 = {
  key: 1,
  class: "grid pointer focus:surface-200",
  tabindex: "0"
}
const _hoisted_24 = { class: "col-8" }
const _hoisted_25 = { class: "blue-text font-bold product-name-label inline-block" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "part-name-label inline-block" }
const _hoisted_28 = { class: "col-4 flex flex-column align-items-end justify-content-between" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-trash pointer",
  style: {"color":"red"}
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "flex align-items-end" }
const _hoisted_34 = { class: "font-bold ml-1" }
const _hoisted_35 = { class: "payment-quantities pr-3" }
const _hoisted_36 = {
  key: 0,
  class: "grid"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-7 text-right" }, "Sub Total", -1))
const _hoisted_38 = { class: "col-5 text-right font-bold" }
const _hoisted_39 = {
  key: 1,
  class: "grid"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-7 text-right" }, "Sales Tax", -1))
const _hoisted_41 = {
  key: 0,
  class: "col-5 text-right font-bold"
}
const _hoisted_42 = {
  key: 1,
  class: "col-5 text-right font-bold"
}
const _hoisted_43 = {
  key: 2,
  class: "col-5 text-right font-bold"
}
const _hoisted_44 = {
  key: 2,
  class: "grid"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-7 text-right" }, "Total", -1))
const _hoisted_46 = { class: "col-5 text-right font-bold" }
const _hoisted_47 = {
  key: 3,
  class: "grid"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-7 text-right" }, "Total", -1))
const _hoisted_49 = { class: "col-5 text-right font-bold" }
const _hoisted_50 = { class: "shipment-additional-info pt-2" }
const _hoisted_51 = {
  key: 0,
  class: "font-semibold flex justify-content-between flex-wrap"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-1 mb-1 inline-block",
  style: {whiteSpace: 'nowrap'}
}, "PO Number: ", -1))
const _hoisted_53 = { class: "blue-text font-bold my-1 ml-auto" }
const _hoisted_54 = { class: "" }
const _hoisted_55 = {
  key: 0,
  class: "products-list-wrapper"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "col-8 py-0" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-trash pointer",
  style: {"color":"red"}
}, null, -1))
const _hoisted_60 = {
  key: 0,
  class: "blue-text font-bold product-name-label inline-block"
}
const _hoisted_61 = {
  key: 1,
  class: "blue-text font-bold product-name-label inline-block"
}
const _hoisted_62 = {
  key: 2,
  class: "blue-text font-bold product-name-label inline-block"
}
const _hoisted_63 = {
  key: 3,
  class: "blue-text font-bold product-name-label inline-block"
}
const _hoisted_64 = {
  key: 4,
  class: "part-name-label inline-block"
}
const _hoisted_65 = {
  key: 5,
  class: "part-name-label inline-block"
}
const _hoisted_66 = { class: "col-4 p-0 flex flex-column align-items-end justify-content-between" }
const _hoisted_67 = { class: "flex align-items-end" }
const _hoisted_68 = { class: "font-bold ml-1" }
const _hoisted_69 = {
  key: 1,
  class: "grid pt-3"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-7 text-right remaining-balance-label font-bold" }, "Remaining Balance", -1))
const _hoisted_71 = { class: "col-5 text-right font-bold text-sm" }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "oa",
  class: "ml-2 font-medium"
}, " Apply Overage to Account ", -1))
const _hoisted_74 = { class: "p-inputgroup mt-2" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  class: "p-inputgroup-addon font-semibold general-label-color",
  style: { width: '104px' }
}, "New Amount", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-0 m-0" }, "Edit Quantity ", -1))
const _hoisted_77 = { class: "card p-0 m-0" }
const _hoisted_78 = {
  class: "grid focus:surface-200 align-items-end",
  tabindex: "0"
}
const _hoisted_79 = { class: "col-11" }
const _hoisted_80 = { class: "blue-text font-bold product-name-label inline-block" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = { class: "part-name-label inline-block" }
const _hoisted_83 = { class: "col-1" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-trash pointer",
  style: {"color":"red"}
}, null, -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = { class: "p-inputgroup mt-2 col-7" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", {
  class: "p-inputgroup-addon font-semibold general-label-color medium-addon",
  style: { width: '104px' }
}, "Quantity", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode("Customer: "),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getCustomer?.name), 1),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getCustomer?.cust_id), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pos.currentOrder, (part, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: part.part_number,
                onClick: ($event: any) => (_ctx.showEditPart(part, index))
              }, [
                (part.part_number)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(part.desc), 1),
                        _createTextVNode(),
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, "Part #: " + _toDisplayString(part.altcode1 || part.part_number), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (this.$route.fullPath !== '/sales/payment' && _ctx.$route.fullPath !== '/sales/confirmation')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              style: {"z-index":"10"},
                              onClick: ($event: any) => (_ctx.removePart($event, index))
                            }, _hoisted_18, 8, _hoisted_16))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_19, "x" + _toDisplayString(parseFloat(part.quantity)), 1),
                        _createElementVNode("div", _hoisted_20, [
                          (part.original_price)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.formatPrice(part.original_price)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatPrice(part.price)), 1)
                        ])
                      ])
                    ]))
                  : (part.so_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, "Order #" + _toDisplayString(part.so_id), 1),
                          _hoisted_26,
                          _createElementVNode("span", _hoisted_27, "Order Date: " + _toDisplayString(part.date), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(part.quantity), 1),
                          (this.$route.fullPath !== '/sales/payment')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                style: {"z-index":"10"},
                                onClick: ($event: any) => (_ctx.removePart($event, index))
                              }, _hoisted_32, 8, _hoisted_30))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, " $" + _toDisplayString(part.order_amount), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_Divider)
              ], 8, _hoisted_9))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          (_ctx.$route.fullPath === '/sales/shipping')
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatPrice(_ctx.total)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$route.fullPath === '/sales/shipping')
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                (_ctx.getTaxAmount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.formatPrice(_ctx.getTaxAmount)), 1))
                  : (_ctx.getTaxLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Calculating..."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_43, "-"))
              ]))
            : _createCommentVNode("", true),
          (_ctx.$route.fullPath === '/sales/shipping')
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.formatPrice(_ctx.totalWithTax)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.formatPrice(_ctx.total)), 1)
              ])),
          _createElementVNode("div", _hoisted_50, [
            (_ctx.getPo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("span", _hoisted_53, _toDisplayString(this.getPo), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_54, [
            (this.$route.fullPath ==='/sales/payment')
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pos.tenders, (tender, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex justify-content-between pointer focus:surface-200",
                      onClick: ($event: any) => (_ctx.updateTender(tender, index))
                    }, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.removeTender($event,index))
                        }, [
                          _hoisted_59,
                          _createTextVNode("  ")
                        ], 8, _hoisted_58),
                        (tender.payment_type === 'CC')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Credit Card  "))
                          : _createCommentVNode("", true),
                        (tender.payment_type === 'CK')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Check  "))
                          : _createCommentVNode("", true),
                        (tender.payment_type === 'CA')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, "Cash  "))
                          : _createCommentVNode("", true),
                        (tender.payment_type === 'ACH')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_63, "e-Check  "))
                          : _createCommentVNode("", true),
                        (tender.payment_type === 'CC')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Ending in " + _toDisplayString(tender.credit_card_no_items[0].credit_card_id.slice(-4)), 1))
                          : _createCommentVNode("", true),
                        (tender.payment_type === 'CK')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, "#" + _toDisplayString(tender.check), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("span", _hoisted_68, " $" + _toDisplayString(tender.check_amount), 1)
                        ])
                      ])
                    ], 8, _hoisted_56))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (this.$route.fullPath === '/sales/payment')
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.formatPrice(_ctx.remainingBalance)), 1)
                ]))
              : _createCommentVNode("", true),
            (this.remainingBalance < 0 && this.$route.fullPath === '/sales/payment')
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.oa,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oa) = $event)),
                    id: "oa",
                    inputId: "oa",
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _hoisted_73
                ]))
              : _createCommentVNode("", true),
            (_ctx.getCustomer && _ctx.$route.name === 'Shipping Information')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  disabled: !_ctx.getOrder || !_ctx.getOrder.length || this.shippingAddress === null,
                  label: "Complete Order",
                  onClick: _ctx.submit,
                  class: "w-full h-3rem mt-3",
                  loading: this.getTaxLoading
                }, null, 8, ["disabled", "onClick", "loading"]))
              : _createCommentVNode("", true),
            (_ctx.$route.name === 'Parts')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 4,
                  style: _normalizeStyle(this.severity),
                  disabled: !_ctx.getOrder || !_ctx.getOrder.length,
                  onClick: _ctx.goToEditQuote,
                  class: "w-full h-3rem mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Create Quote")
                  ]),
                  _: 1
                }, 8, ["style", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$route.name === 'Parts')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 5,
                  style: _normalizeStyle(this.severity),
                  disabled: !_ctx.getOrder || !_ctx.getOrder.length,
                  onClick: _ctx.goToShipping,
                  class: "w-full h-3rem mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Create Order")
                  ]),
                  _: 1
                }, 8, ["style", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$route.name === 'Payment')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 6,
                  style: _normalizeStyle(this.severity),
                  disabled: _ctx.remaining,
                  onClick: _ctx.submit,
                  class: "w-full h-3rem mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit Payment(s)")
                  ]),
                  _: 1
                }, 8, ["style", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showTenderAmountModal,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showTenderAmountModal) = $event)),
      modal: ""
    }, {
      header: _withCtx(() => [
        _createTextVNode(" Update Amount Charged ")
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Submit",
          icon: "pi pi-check",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateTenderAmount()))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createVNode(_component_InputText, {
            modelValue: _ctx.newTndrAmt,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTndrAmt) = $event)),
            id: "reg",
            class: "text-sm",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.updateTenderAmount()), ["enter"]))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.editPart)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          visible: _ctx.visibleEditPart,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visibleEditPart) = $event)),
          modal: "",
          class: "w-5 xl:w-3"
        }, {
          header: _withCtx(() => [
            _hoisted_76
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Update Quantity",
              icon: "pi pi-check",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updatePart(_ctx.editPart)))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.editPart.desc), 1),
                  _createTextVNode(),
                  _hoisted_81,
                  _createElementVNode("span", _hoisted_82, "Part #: " + _toDisplayString(_ctx.editPart.part_number), 1)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("span", {
                    style: {"float":"right"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeEditPart($event, _ctx.editPart.index)))
                  }, _hoisted_85)
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _hoisted_87,
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.editPart.quantity,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editPart.quantity) = $event)),
                    id: "quantity",
                    class: "text-sm ml-0 update-qty-input",
                    step: _ctx.calculateStep(_ctx.editPart),
                    min: 1,
                    inputProps: { inputmode: 'numeric'},
                    showButtons: "",
                    buttonLayout: "horizontal",
                    incrementButtonIcon: "pi pi-plus",
                    decrementButtonIcon: "pi pi-minus"
                  }, null, 8, ["modelValue", "step"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}